import { Box, useTheme } from "@mui/material";
import { ReactNode } from "react";

export type SpaceProps = {
    height?: number;
    space?: () => ReactNode;
};

export const Space = (props: SpaceProps) => {
    const { height = 4, space: SpaceContent } = props;

    const theme = useTheme();

    return (
        <Box
            sx={{
                maxHeight: theme.spacing(height),
                width: "100%",
                position: "relative",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box
                sx={{
                    minHeight: theme.spacing(height),
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    // No choice here, we are obligated to make an class injection in Puck Slot component and
                    // override aggressively the minHeight property since the style are not exposed
                    "& > div[class*='_DropZone_']": {
                        minHeight: `${theme.spacing(height)} !important`,
                    },
                }}
            >
                {SpaceContent && <SpaceContent />}
            </Box>
        </Box>
    );
};
